import * as printJS from 'print-js';

/**
 * 药品订单打印数据结构
 *
 * @export
 * @interface IPrintMedicineOrderData
 */
export interface IPrintMedicineOrderData {
  short_name: string;
  med_type: string;
  brand_name: string;
  order_volume_dose: string;
}

/**
 * 处方订单打印数据结构
 *
 * @export
 * @interface IPrintPrescriptionOrderData
 */
export interface IPrintPrescriptionOrderData {
  short_name: string;
  med_type: string;
  brand_name: string;
  each_dose_amount: string;
  prescription_amount: string;
  total_dose_amount: string;
  order_category_prescription: string;
}

/**
 * 打印表头结构
 *
 * @export
 * @interface IPrintProperty
 */
export interface IPrintProperty {
  field: string;
  displayName: string;
}

export class UtilPrint {
  /**
   * 打印json数据
   *
   * @memberof UtilPrint
   */
  static printJsonData = (header: string, data: any, properties: any) => {
    printJS({
      printable: data,
      type: 'json',
      properties,
      documentTitle: ' ',
      header: `<h3 class="custom-h3">${header}</h3>`,
      style: '.custom-h3 { text-align: center; font-size: 24px; font-weight: normal; }',
      gridHeaderStyle:
        'font: 14px normal; padding: 0 10px 0 20px; border: 1px solid #dddddd; height: 40px; text-align: left; background-color: #f5f5f5; width: auto;',
      gridStyle: 'font: 14px normal; padding: 0 10px 0 20px; border: 1px solid #dddddd; height: 40px; text-align: left; width: auto;',
    });
  };

  static printRawHtml(html: string, style: string) {
    printJS({
      printable: html,
      type: 'raw-html',
      style,
    });
  }

  /** pdf 打印 */
  static printPdf(printData: string, base64: boolean): void {
    printJS({
      type: 'pdf',
      base64,
      printable: printData,
      // showModal: true,
    });
  }

  /** blob 转 base64 */
  static async blob2Base64(blob: Blob): Promise<string | undefined> {
    const dataUri = (await this.blob2DataURI(blob)) as string;
    const uriArr = dataUri.split(',');
    if (uriArr.length > 0) {
      return uriArr[1];
    }
    return undefined;
  }

  /** blob 转 dataUri */
  static async blob2DataURI(blob: Blob): Promise<string | ArrayBuffer> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        if (e.target) {
          resolve(e.target.result as string | ArrayBuffer);
        }
      };
    });
  }

  /**
   * 手机号码脱敏
   * @param mobile
   */
  static hideMobile(mobile: string) {
    return mobile.substr(0, 3) + '****' + mobile.substr(7, 4);
  }
}



// WEBPACK FOOTER //
// ./src/utils/print.ts